import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Grid,
  TextField,
  Typography,
  IconButton,
  Chip,
  InputAdornment,
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import Pause from "@mui/icons-material/Pause";
import { capitalize } from "lodash";
import AudioButton from "../../Components/Media/AudioButton";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";
import CircularProgress from "@mui/material/CircularProgress";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { fetchProduct } from "../../Store/Slices/ProductSlice";

import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";

import { getWordsByPagination } from "./Services";
import { unicodeToString } from "../../Js/Common";
import { getAsset } from "../../Js/Common";
import WordsInSlide from "./WordsInSlide";

//const languages = ["English", "French", "Hindi", "Sanskrit"];
let languages = ["English", "French"];

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const MTI = (props) => {
  const classes = useStyles();
  const listInnerRef = useRef();
  const paginationVal = 10;

  // Hooks
  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // State
  const [wordsNode, setWordsNode] = useState(null);
  const [nodeList, setNodeList] = useState([]);
  const [assets, setAssets] = useState([]);
  const [assetData, setAssetData] = useState(null);
  const [words, setWords] = useState([]);
  const [searchString, setSearchString] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const [isFetching, setIsFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [currentWord, setCurrentWord] = useState(null);
  const [currentPOS, setCurrentPOS] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { siteConfig } = useSelector((state) => state.defs);
  let { productId, productVersion } = useSelector(
    (state) => state.defs.siteConfig.products[0]
  );
  const { serverRole } = useSelector((state) => state.defs);

  let productData = useSelector((state) => state.product.productData);

  useEffect(() => {
    let data = productData;
    if (data) {
      dispatch(commonSliceActions.setLoader(false));
      if (typeof data == "string") {
        data = JSON.parse(data);
      }
      console.log("!@!@#$$@", data);
      let courseObj;
      if (typeof data[0]["course_data"] == "string") {
        courseObj = JSON.parse(data[0]["course_data"]);
      } else {
        courseObj = data[0]["course_data"];
      }
      setWordsNode(courseObj["data"][1]["data"][0]);
      //setIsLoading(false);
    } else {
      dispatch(commonSliceActions.setLoader(true));
      const innerFun = async () => {
        dispatch(
          fetchProduct({
            productId: productId,
            productVersion: productVersion,
          })
        );
      };
      innerFun();
    }
  }, [productData]);

  useEffect(() => {
    if (wordsNode && wordsNode.data?.length > 0) {
      let nodesList = wordsNode.data.map((val) => {
        return {
          id: val.id,
          value: val.value,
        };
      });
      console.log("nodesList", nodesList);
      setNodeList(nodesList);
    }
  }, [wordsNode]);

  useEffect(() => {
    if (siteConfig) {
      let temparray = [...languages];
      console.log("siteConfig", siteConfig);
      if (siteConfig?.customer?.addOnInfo?.isDefence) {
        temparray.push("Defence");
      } else {
        const index = temparray.indexOf("Defence");
        if (index > -1) {
          // only splice array when item is found
          temparray.splice(index, 1); // 2nd parameter means remove one item only
        }
      }
      //setLanguageList(temparray);
    }
  }, [siteConfig]);

  const handleChange = (event) => {
    console.log(":S:S:S", event.target.value);
    let foundNode = wordsNode.data.find((val) => val.id == event.target.value);
    if (foundNode) {
      setAssets(foundNode.data);
    }
    setAssetData(null);
    setIsLoading(true);
    setSelectedLanguage(event.target.value);
  };

  useEffect(() => {
    const getData = setTimeout(async () => {
      setCurrentPage(1);
      setTotalData(0);
      setWords([]);
      if (searchString && searchString.trim().length > 0) {
        //fetchWords(1);
      }
      if (searchString.trim().length == 0) {
        setIsLoading(false);
        setCurrentWord(null);
      }
    }, 2000);

    return () => clearTimeout(getData);
  }, [searchString, selectedLanguage]);

  // Fetch Words Data
  const fetchAssets = async (id) => {
    console.log("id", id);
    let assetData = await getAsset(id);
    if (serverRole != "" && serverRole != "WEB_HOST") {
      let myId = assetData.data[0].asset_uid;
      let assetDataLocal = { ...assetData.data[0] };
      assetDataLocal.asset_uid = null;
      setAssetData(assetDataLocal);
      setTimeout(() => {
        assetDataLocal.asset_uid = myId;
        setAssetData(assetDataLocal);
      }, [500]);
    }
    setAssetData(assetData.data[0]);
    console.log(":S:S:S::S:S", assetData);
    setIsLoading(false);
  };

  const loadMore = () => {
    setCurrentPage((val) => val + 1);
    //fetchWords(currentPage + 1);
  };

  const currentAssetSelection = (obj) => {
    fetchAssets(obj.id);
  };

  return (
    <>
      <IconButton onClick={handleClickOpen}>
        <BusinessCenterIcon
          sx={{
            color: "#DB8829",
            borderRadius: "50%",
            padding: 0.4,
            fontSize: "1.8rem",
            "@media (min-width: 1636px)": {
              fontSize: "2.2rem",
            },
          }}
        />
      </IconButton>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Tools
            </Typography>
          </Toolbar>
        </AppBar>
        <>
          {wordsNode && wordsNode.data.length > 0 && (
            <Grid container gap={1} justifyContent={"space-around"} mt={2}>
              <Grid item xs={3}>
                <Grid item sm={12}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Types</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={selectedLanguage}
                      label="Types"
                      onChange={handleChange}
                    >
                      {nodeList &&
                        nodeList.length > 0 &&
                        nodeList.map((val, index) => {
                          return (
                            <MenuItem value={val.id}>{val.value}</MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid
                  item
                  sm={12}
                  sx={{
                    border: 1,
                    borderRadius: 2,
                    borderColor: "#CCCCCC",
                    mt: 2,
                  }}
                >
                  <Box
                     
                    sx={{ height: "62vh", overflow: "auto" }}
                    ref={listInnerRef}
                    // onScroll={() => {
                    //   if (handleInfinityScroll()) {
                    //     handleLoadMore();
                    //   }
                    // }}
                  >
                    <List>
                      {assets &&
                        assets.length > 0 &&
                        assets.map((asset) => {
                          return (
                            <ListItem
                              disablePadding
                              sx={
                                {
                                  backgroundColor:
                                    asset.id == assetData?.asset_uid
                                      ? "#d9dffc"
                                      : "#FFFFFF",
                                  color:
                                    asset.id == assetData?.asset_uid
                                      ? "#DB8829"
                                      : "#000000",
                                }
                              }
                            >
                              <ListItemButton
                                onClick={() => {
                                  currentAssetSelection(asset);
                                }}
                              >
                                <ListItemText
                                  primary={asset.value}
                                  primaryTypographyProps={
                                    {
                                      // fontWeight:
                                      //   word.uid == currentWord?.uid ? "bold" : "300",
                                    }
                                  }
                                />
                              </ListItemButton>
                            </ListItem>
                          );
                        })}
                    </List>
                  </Box>
                </Grid>
              </Grid>
              <Grid
                item
                sm={8}
                sx={{ border: 1, borderRadius: 2, borderColor: "#CCCCCC", p:1 }}
              >
                {assetData && assetData.content && (
                  <WordsInSlide content={assetData.content.content} />
                )}
              </Grid>
            </Grid>
          )}
          {!wordsNode ||
            (wordsNode && wordsNode.data.length == 0 && (
              <Grid
                 
                container
                sx={{ mt: 2, justifyContent: "center" }}
              >
                <Typography fontSize={22} color={"#999"} marginTop={20}>
                  MTI & Gloassry data not available.
                </Typography>
              </Grid>
            ))}
        </>
      </Dialog>
    </>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default MTI;
